import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./confirmation.css";
import apiRequest from "../apiCall";
import { useDispatch } from "react-redux";
import { setLoading } from "../Redux/action";

const Confirmation = () => {
  const [summary, setSummary] = useState([]);
  const [order, setOrder] = useState([]);

  document.title = "Thank You";

  const storedData = localStorage.getItem("userData") || " {}";
  const userData = JSON.parse(storedData);
  const CustomerID = userData ? userData.id : null;

  const dispatch = useDispatch();

  useEffect(() => {
    resize();
  }, []);

  const [customerData, setCustomerData] = useState({});
  useEffect(() => {
    apiRequest(
      "GET",
      `orderDetailslast/${CustomerID}`,
      null,
      false,
      false
    ).then((response) => {
    dispatch(setLoading(true));
      const orderData = response; 
      setSummary(orderData);
      setCustomerData(JSON.parse(orderData.CustomerDetails));
      dispatch(setLoading(false));
    });
  }, []);

  const resize = () => {
    const email = document.getElementsByClassName("email");

    for (let i = 0; i < email.length; i++) {
      if (email[i].offsetWidth > document.body.offsetWidth / 5) {
        email[i].classList.add("overflow");
        email[i].classList.add("overflow");
      } else {
        email[i].classList.remove("overflow");
      }
    }
  };

  window.addEventListener("resize", resize);

  return (
    <div className="confirmation">
      <div className="order-conf">
        <h2>
          Thank you {customerData?.firstName} {customerData?.lastName}
        </h2>
        <br />
        <span>Your order is confirmed.</span> <br />
      </div>
      <div className="order-conf">
        <h4>Your Order Number is- {summary.OrderNumber} </h4>
      </div>
      <div className="order-updated sec">
        <h3>Your order is Redirected to {summary.ChemistName}</h3>
        <span>
          You’ll receive a confirmation email with your order number shortly.
        </span>

        <p style={{ fontSize: "15px" }}>
          Chemist Address: {summary.Address} - {summary.PinCode}
        </p>
        <p style={{ fontSize: "15px" }}>
          {" "}
          Chemist Mobile Number: {summary.Mobile}
        </p>
      </div>

      <div className="sec order-info">
        <h2>Order updates</h2>
        <main>
          <section className="ls">
            <span>Contact information</span>
            <p className="email">Email : {summary.CustomerEmail}</p>
            <p className="email">Mobile No. : {summary.CustomerPhone}</p>
            <span>Shipping address</span>
            <p style={{ width: "50%" }}>
              {customerData?.firstName} {customerData?.lastName}
              <br />
              {customerData?.address}
              <br /> {summary.CustomerPhone}
            </p>
          </section>
          <section className="rs">
            <span>Payment method</span>
            <p>COD (cash on delivery)</p>
            <span>Shipping method</span>
            <p>Standard (cash on delivery)</p>
          </section>
        </main>
        <br />
        <br />
        <div className="last-button">
          <Link className="List" to="/">
            Return to Home
          </Link>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
};

export default Confirmation;
